import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { parse, stringify } from 'query-string';

function useRouting() {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    const parseLocationSearch = (search = '') => {
        return parse(search || location.search) || {};
    }

    const stringifyParams = params => {
        return stringify(params, {skipEmptyString: true});
    }

    return {
        navigate,
        params,
        location,
        parseLocationSearch,
        stringifyParams
    }
}

export {
    useRouting
}
